module.exports = __webpack_public_path__ + "img/2m-logo.b8c8d151.png";